import { render, staticRenderFns } from "./ElibraryJurnalView.vue?vue&type=template&id=a6f96486&scoped=true"
import script from "./ElibraryJurnalView.vue?vue&type=script&lang=js"
export * from "./ElibraryJurnalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f96486",
  null
  
)

export default component.exports